import React, { ComponentPropsWithoutRef } from 'react';
import { Button } from '@rbx/ui';
import DynamicallyRouted from '@modules/miscellaneous/common/components/DynamicallyRouted';
import { resolveStaticHref } from '../utils/staticLinkUtils';

type MarkdownButtonProps = ComponentPropsWithoutRef<typeof Button>;

export default function MarkdownButton({ href, children, ...otherProps }: MarkdownButtonProps) {
  if (typeof href !== 'undefined') {
    return (
      <DynamicallyRouted.Button href={resolveStaticHref(href)} {...otherProps}>
        {children?.props?.children ?? children}
      </DynamicallyRouted.Button>
    );
  }

  return <Button {...otherProps}>{children?.props?.children ?? children}</Button>;
}
